import { render, staticRenderFns } from "./NavbarDesktopSmallImageBlocks.vue?vue&type=template&id=72398064&scoped=true&lang=pug&"
import script from "./NavbarDesktopSmallImageBlocks.vue?vue&type=script&lang=js&"
export * from "./NavbarDesktopSmallImageBlocks.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDesktopSmallImageBlocks.vue?vue&type=style&index=0&id=72398064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72398064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72398064')) {
      api.createRecord('72398064', component.options)
    } else {
      api.reload('72398064', component.options)
    }
    module.hot.accept("./NavbarDesktopSmallImageBlocks.vue?vue&type=template&id=72398064&scoped=true&lang=pug&", function () {
      api.rerender('72398064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/NavbarDesktopSmallImageBlocks.vue"
export default component.exports